import { render, staticRenderFns } from "./StudentAttendanceForm.vue?vue&type=template&id=139a8e4d"
import script from "./StudentAttendanceForm.vue?vue&type=script&lang=js"
export * from "./StudentAttendanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports